/* eslint-env browser */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import axios from '~utils/axios';

import * as Sentry from '@sentry/gatsby';
import FieldHelpText from '~components/forms/HelpText';

import LEOAddresses from './LEOAddresses';

export default function LEOData({ state, region }) {
  const [data, setData] = useState(null);
  const [loadingError, setLoadingError] = useState(null);

  useEffect(() => {
    let canceled = false;

    setData(null);
    setLoadingError(null);

    axios
      .get(`official/region/${region}/`)
      .then(({ data: newData }) => {
        if (canceled) {
          return;
        }

        setData(newData);
      })
      .catch((err) => {
        if (canceled) {
          return;
        }

        Sentry.captureException(err);
        setLoadingError('Error loading regions. Please try again.');
      });

    return () => {
      canceled = true;
    };
  }, [region, state]);

  if (loadingError) {
    return <FieldHelpText isError>{loadingError}</FieldHelpText>;
  }

  if (!data) {
    return <h3 className='mt-10'>Loading...</h3>;
  }

  if (data.offices.length === 0 || data.offices[0].addresses.length === 0) {
    return (
      <p>
        Sorry, we don&apos;t have contact information for your local election
        office.
      </p>
    );
  }

  return (
    <>
      <LEOAddresses
        addresses={data.offices[0].addresses}
        hours={data.offices[0].hours}
      />
      <p className='mt-10 text-base text-secondary'>
        Civic Data Provided by U.S. Vote Foundation
      </p>
    </>
  );
}

LEOData.propTypes = {
  region: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
};
